<template>
    <div>
        <b-card>
        <b-row>
            <b-col cols="5">
                <!-- table -->
                <b-form-group label="Add Product Set" label-for="product-set">
                    <b-input-group>
                        <b-form-input id="card" placeholder="Set Name" v-model="set_add" trim/>
                        <b-input-group-append>
                            <b-button variant="outline-primary" @click="add_product_set()">
                                Add
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
                <b-table
                    ref="selectableTable"
                    selectable
                    :select-mode="selectMode"
                    :items="items"
                    :fields="fields"
                    responsive
                    striped
                    class="mb-0"
                    @row-selected="onRowSelected">
                    <template #cell(actions)="data">
                        <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">
    
                            <template #button-content>
                                <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body"/>
                            </template>
                            <b-dropdown-item :to="{ name: 'apps-Member-view', params: { id: data.item.id } }">
                                <feather-icon icon="FileTextIcon"/>
                                <span class="align-middle ml-50">Details</span>
                            </b-dropdown-item>
    
                            <b-dropdown-item :to="{ name: 'apps-Member-edit', params: { id: data.item.id } }">
                                <feather-icon icon="EditIcon"/>
                                <span class="align-middle ml-50">Edit</span>
                            </b-dropdown-item>
    
                            <b-dropdown-item>
                                <feather-icon icon="TrashIcon"/>
                                <span class="align-middle ml-50">Delete</span>
                            </b-dropdown-item>
                        </b-dropdown>
                    </template>
                    <template #cell(status_number)="data">
                        <b-badge :variant="status[1][data.value]">
                            {{ status[0][data.value] }}
                        </b-badge>
                    </template>
                </b-table>
            </b-col>
            <b-col cols="7">
                <h6>Product Set Detail <span v-if="selected_product_set != null">{{ selected_product_set.name }} #{{selected_product_set.id}}</span></h6>
                <b-form-group label="Add Product" label-for="payment-method">
                    <b-row>
                        <b-col cols="12" class="mb-1">
                            <v-select v-model="add.product_id" :clearable="true" label="label" :options="product_list" :reduce="product => product.id" />
                        </b-col>
                        <b-col cols="12" class="mb-1">
                            <v-select v-model="add.short_course_id" :clearable="true" label="label" :options="short_courses" :reduce="short_courses => short_courses.id" />
                        </b-col>
                        <b-col cols="12" class="mb-1">
                            <v-select v-model="add.form_id" :clearable="true" label="label" :options="form_list" :reduce="form => form.id" />
                        </b-col>
                        <b-col cols="6">
                            <v-select v-model="add.selector" :clearable="false" label="label" :options="['未有','A','B','C','D','E','F','G']" />
                        </b-col>
                        <b-col cols="6">
    
                            <b-input-group>
                                <b-form-input id="card"  placeholder="加購價" v-model="add.addon_amount" trim />
                                <b-input-group-append>
                                    <b-button variant="outline-primary"  @click="add_product()" :disabled="selected_product_set == null">
                                        Add
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-row>
                </b-form-group>
                <hr/>
                <b-list-group>
                    <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="record in selected_set">
                        <b-badge :class="record.selector_name">{{ record.selector_name }}</b-badge>
                        
                        <span>{{ record.item_name }} <b-badge  :variant="amount_class(record.addon_amount)" v-if="record.addon_amount != 0">${{ record.addon_amount }}</b-badge></span>
                       
                        <font-awesome-icon icon="fa-solid fa-xmark" style="color:red" @click="delete_product(record.set_item_id)"/>
                       
    
                    </b-list-group-item>
                </b-list-group>
            </b-col>
        </b-row>
    </b-card>
    </div>
    </template>
    
    <script>
    import BCardCode from '@core/components/b-card-code/BCardCode.vue'
    
    import vSelect from 'vue-select'
    import Ripple from 'vue-ripple-directive'
    var numeral = require('numeral');
    import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

    import router from '@/router'
    import {
      BCard, BTable, BAvatar, BCardBody, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend, BListGroup, BListGroupItem
    } from 'bootstrap-vue'
    
    export default {
      components: {
        router,
        ToastificationContent,
        BCard,
        BBadge,
        BListGroup,
        BListGroupItem,
        BTable,
        BAvatar,
        BBadge,
        BRow,
        vSelect,
        BCol,
        BFormGroup,
        BFormSelect,
        BPagination,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BInputGroupPrepend,
        BButton,
        BPagination,
        BCardCode,
        BTable,
        BButton,
        BFormGroup,
        BAvatar,
        BCardBody,
        BBadge,
        vSelect,
      },
      directives: {
        Ripple,
      },
      data() {
        return {
          set_add: null,
          set_id: null,
          selected_product_set:null,
          bar_add : {
            amount : null,
            percentage : null
          },
          add : {
            product_id : null,
            short_course_id: null,
            form_id: null,
            addon_amount: null,
            selector: '未有'
          },
          selected_set_enable: true,
          centerOptions: [],
          packageOptions: [],
          product_list:[],
          short_courses:[],
          selected_set:[],
          classOptions: [],
          isAddNewPackageSidebarActive: false,
          searchString: null,
          perPage: 10,
          startRow: 1,
          endRow: 10,
          pageOptions: [10, 15, 20],
          totalRows: 1,
          currentPage: 1,
          fields: [{ key: 'name', label: 'Set Name' }, {key: 'created_at', label: 'Created at'}],
          /* eslint-disable global-require */
          items: [],
          /* eslint-disable global-require */
          status: [{
            1: 'GRANT', 2: 'DENY'
          },
          {
            1: 'light-success', 2: 'light-danger'
          }],
          selectMode: 'single',
          selected: [],
        }
      },
      props: {
        userData : {
          type: Object
        }
      },
      watch: {
        userData: {
          handler(newValue, oldValue) {
            this.get_data()
          },
        },
        currentPage: {
          handler(newValue, oldValue) {
            this.get_data()
          },
        },
        searchString: {
          handler(newValue, oldValue) {
            // console.log("search")
            this.handleSearch()
          },
        },
        perPage: {
          handler(newValue, oldValue) {
            if (newValue < 9) {
              this.perPage = 10
            }
            // console.log("search")
            this.handleSearch()
          },
        },
      },
      created() {
        this.get_data()
        this.get_product_list()
        this.get_form_list()
        this.get_short_course()
        console.log(numeral(1000).format('0,0.00'))
      },
      methods: {
        amount_class(amount) {
            if (amount < 0) {
                return 'danger'
            } else {
                return 'warning'
            }
        },
        delete_product(id) {
          this.$http.post(process.env.VUE_APP_API_BASE+`/product_set/`+ this.selected_product_set.id + `/item/delete/`,{ id:id })
            .then(res => {
                this.get_data()
                this.get_product_set([this.selected_product_set])
            })
        },
        add_product_set() {
          this.$http.post(process.env.VUE_APP_API_BASE+`/product_set/`,{name:this.set_add})
            .then(res => {
              this.get_data()
            })
        },
        add_product() {
          this.$http.post(process.env.VUE_APP_API_BASE+`/product_set/` + this.selected_product_set.id + `/item/`,  { item:this.add })
            .then(res => {
                if (res.data.result === false) {
                    this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                        title: 'Error',
                        icon: 'XIcon',
                        variant: 'danger',
                        text: res.data.message,
                    },
                    })
                }
              this.get_data()
              this.add = this.$options.data().add
              this.get_product_set([this.selected_product_set])
            })
        },
        add_bar() {
          this.$http.post(process.env.VUE_APP_API_BASE+`/commissions/set/`+this.set_id+`/`,{bar:this.bar_add})
            .then(res => {
              this.selected_set = res.data.records
              this.bar_add.amount = null
              this.bar_add.percentage = null
            })
        },
        to_numeral(number) {
          return numeral(number).format('0,0.00')
        },
        get_product_list() {
          this.$http.get(process.env.VUE_APP_API_BASE+'/products/?status=ACTIVE')
            .then(res => {
              this.product_list = res.data.products
            })
        },
         get_form_list() {
          this.$http.get(process.env.VUE_APP_API_BASE+'/forms/')
            .then(res => {
              this.form_list = res.data.forms
            })
        },
        get_short_course() {
          this.$http.get(process.env.VUE_APP_API_BASE+'/short_courses/?type=ALL')
            .then(res => {
              this.short_courses = res.data.short_courses
            })
        },
        one() {
          this.isAddNewPackageSidebarActive = false
          this.get_data()
        },
        get_data() {
         
           this.$http.get(process.env.VUE_APP_API_BASE+`/product_set/`)
             .then(res => {
               this.items = res.data.product_set
               this.totalRows = res.data.total
             })
           
        },
        get_product_set(set) {
          this.set_id = set[0].id
           this.$http.get(process.env.VUE_APP_API_BASE+`/product_set/`+set[0].id+`/`)
             .then(res => {
                this.selected_product_set = set[0]
               this.selected_set = res.data.detail
             })
        },
        handleChangePage() {
    
        //  this.get_data()
        },
        onRowSelected(items) {
          this.get_product_set(items)
        },
        selectAllRows() {
          this.$refs.selectableTable.selectAllRows()
        },
        clearSelected() {
          this.$refs.selectableTable.clearSelected()
        },
        selectThirdRow() {
          // Rows are indexed from 0, so the third row is index 2
          this.$refs.selectableTable.selectRow(2)
        },
        unselectThirdRow() {
          // Rows are indexed from 0, so the third row is index 2
          this.$refs.selectableTable.unselectRow(2)
        },
    
        handleSearch() {
          // let _print = `The user searched for: ${searching}\n`
          // this.$refs.pre.appendChild(document.createTextNode(_print))
        // this.searchString = searching
        // this.currentx = 1
        // this.get_data()
          this.searchTimeOut()
        },
        searchTimeOut() {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            // your code
            this.currentPage = 1
            this.get_data()
          }, 500)
        },
      },
    }
    </script>
    
    <style lang="scss">
    .b-table-selectable{
      .feather{
        font-size: 1.3rem;
      }
    }
    
.A {
    background: #ca9b01;
}
.B {
    background: #ca0101;
}
.C {
    background: #016eca;
}
.D {
    background: #01ca47;
}
.E {
    background: #9c01ca;
}
.F {
    background: #333;
}
.G {
    background: #a8ab59;
}
.H {
  background: #598aab;
}
    </style>
    